export default __webpack_public_path__ + "static/media/destroy-white.27e19830.md";